import { render, staticRenderFns } from "./NewsWrite.vue?vue&type=template&id=20f60d32&scoped=true"
import script from "./NewsWrite.vue?vue&type=script&lang=js"
export * from "./NewsWrite.vue?vue&type=script&lang=js"
import style0 from "./NewsWrite.vue?vue&type=style&index=0&id=20f60d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f60d32",
  null
  
)

export default component.exports